// トレーニング履歴（日次）.
import * as React from 'react';
import { JS_VOID } from '../../utils/commonUtil';
import { MDate } from '../../utils/dateUtil';
import Calendar, { DummyCalendar } from './Calendar';
import * as PropTypes from 'prop-types';
import * as TrainingConst from '../../constants/Training';
import { Training, TrainingMenu } from '../../constants/Training';

// ローディング中のダミー・トレーニング履歴（日次）props.
interface DummyDailyHistoryProps extends React.Props<{}> {
  // 親からの引き渡し用.
  mDate: MDate;
}

// ローディング中のダミー・トレーニング履歴（日次）.
export class DummyDailyHistory extends React.Component<DummyDailyHistoryProps, {}> {
  yearSelected: string;
  monthSelected: string;
  daySelected: string;

  componentWillMount() {
    const mDate: MDate = this.props.mDate;
    this.yearSelected = mDate.year;
    this.monthSelected = mDate.month;
    this.daySelected = mDate.day;
  }

  render() {
    return (
      <section id="sec03">
        <h2 className="ttlStyle01">トレーニング履歴（日次）</h2>
        <div className="inner">
          <div className="calendarHeader">
            <div className="dateArea">
              <div className="date">{this.yearSelected}
                <span className="year">年</span>{this.monthSelected}
                <span>月</span>{this.daySelected}
                <span>日</span>
              </div>
              <div className="btn left">
                <a/>
              </div>
              <div className="btn right">
                <a/>
              </div>
            </div>
            <div className="btnStyle05">
              <a>比較する</a>
            </div>
          </div>
          <table className="tblStyle02">
            <colgroup>
              <col/>
              <col/>
              <col/>
              <col/>
              <col/>
            </colgroup>
            <thead>
              <tr>
                <th scope="col">項目</th>
                <th scope="col">回数</th>
                <th scope="col">平均角度</th>
                <th scope="col" colSpan={2}>動作時間</th>
              </tr>
            </thead>
            <tbody />
          </table>
          <DummyCalendar />
        </div>
      </section>
    );
  }
}

// トレーニング履歴（日次）props
interface DailyHistoryProps extends React.Props<{}> {
  // response内容.
  trainingMenus: TrainingMenu[];
  history: any;

  // 親からの引き渡し用.
  mDate: MDate;

  // 種類.
  type: TrainingConst.TYPE;
}

// トレーニング履歴（日次）.
export default class DailyHistory extends React.Component<DailyHistoryProps, {}> {
  yearSelected: string;
  monthSelected: string;
  daySelected: string;
  mDate: MDate;

  static get contextTypes() {
    // 親のLocomoコンポーネントと橋渡しするcontext.
    return {
      // 左右.
      callbackParent: PropTypes.func,
      // 比較.
      changeState: PropTypes.func,
    };
  }

  componentWillMount() {
    this.mDate = this.props.mDate;
    this.yearSelected = this.mDate.year;
    this.monthSelected = this.mDate.month;
    this.daySelected = this.mDate.day;
  }

  // 比較するをクリックしたときの処理.
  toLocomoCompare = () => {
    // 親contextのメソッド.
    this.context.changeState(TrainingConst.COMPARE_STATE);
  }

  shouldComponentUpdate(nextProps: DailyHistoryProps, nextState: any): boolean {
    const propsDiff = nextProps === this.props;
    const stateDiff = nextState === this.state;
    return !(propsDiff && stateDiff);
  }

  // 左をクリックしたときの処理.
  minusDaily = (yearSelected: string, monthSelected: string, daySelected: string) => {
    // 前日.
    const bkYearmonth: string = this.mDate.yearmonth;
    this.mDate.setPreDate();
    this.yearSelected = this.mDate.year;
    this.monthSelected = this.mDate.month;
    this.daySelected = this.mDate.day;

    this.setState({date: this.mDate});

    // 変化があったとき.
    if (bkYearmonth !== this.mDate.yearmonth) {
      // 親contextのメソッド.
      this.context.callbackParent(this.mDate.yearmonth);
    }
  }

  // 右をクリックしたときの処理.
  plusDaily = (yearSelected: string, monthSelected: string, daySelected: string) => {
    // 次の日.
    const bkYearmonth: string = this.mDate.yearmonth;
    this.mDate.setNextDate();
    this.yearSelected = this.mDate.year;
    this.monthSelected = this.mDate.month;
    this.daySelected = this.mDate.day;

    this.setState({date: this.mDate});

    // 変化があったとき.
    if (bkYearmonth !== this.mDate.yearmonth) {
      // 親contextのメソッド.
      this.context.callbackParent(this.mDate.yearmonth);
    }
  }

  render() {
    // 日次.
    // self.historyの中から今日の日付と一致するdictionaryを格納.
    let trainingOfSelectedDate: any[] = [];
    // '2017-03-03';
    const selectedDate: string = `${this.yearSelected}-${this.monthSelected}-${this.daySelected}`;
    // 存在例: 2017年08月06日
    // const selectedDate: string = `2017-08-06`;

    for (let key in this.props.history) {
      if (selectedDate === key) {
        trainingOfSelectedDate = this.props.history[key];
        break;
      }
    }

    return (
      <section id="sec03">
        <h2 className="ttlStyle01">トレーニング履歴（日次）</h2>
        <div className="inner">
          <div className="calendarHeader">
            <div className="dateArea">
              <div className="date">{this.yearSelected}
                <span className="year">年</span>{this.monthSelected}
                <span>月</span>{this.daySelected}
                <span>日</span>
              </div>
              <div className="btn left">
                <a
                  href={JS_VOID}
                  onClick={event => this.minusDaily(this.yearSelected, this.monthSelected, this.daySelected)}
                />
              </div>
              <div className="btn right">
                <a
                  href={JS_VOID}
                  onClick={event => this.plusDaily(this.yearSelected, this.monthSelected, this.daySelected)}
                />
              </div>
            </div>
            <div className="btnStyle05">
              <a onClick={event => this.toLocomoCompare()}>比較する</a>
            </div>
          </div>
          <table className="tblStyle02">
            <colgroup>
              <col/>
              <col/>
              <col/>
              <col/>
              <col/>
            </colgroup>
            <thead>
              <tr>
                <th scope="col">項目</th>
                <th scope="col">回数</th>
                <th scope="col">平均角度</th>
                <th scope="col" colSpan={2}>動作時間</th>
              </tr>
            </thead>
            <tbody>
              {
                // ある時だけ表示される.
                Object.keys(trainingOfSelectedDate).map((index: any) => {
                  const training: Training = trainingOfSelectedDate[index];
                  const key = `DailyTable${index}`;
                  // Locomoの項目内にあるものだけ表示(1~7)
                  if ((index >= TrainingConst.LOCOMO_MIN_NO && index <= TrainingConst.LOCOMO_MAX_NO) ||
                    (index >= TrainingConst.ADL_MIN_NO && index <= TrainingConst.ADL_MAX_NO)) {
                   return <tr key={key}>
                    {this.props.trainingMenus.map((trainingMenu: TrainingMenu, i: number) => {
                      if (trainingMenu.id === Number(index)) {
                        const headKey = `DailyTableHead${index}`;
                        return <th key={headKey}>{trainingMenu.name}</th>;
                      }

                      // 該当しないときはパス
                      return;
                    })}
                    <td>{training.count}</td>
                    <td>{training.average_angle}度</td>
                    <td>{training.average_duration}秒</td>
                    <td />
                  </tr>;
                  } else {
                    return (null);
                  }
                }
              )}
            </tbody>
          </table>
          <Calendar
            type={this.props.type}
            history={this.props.history}
            mDate={this.props.mDate}
          />
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/DailyHistory.tsx